import { MarketplaceStoreSelector } from '@common/selectors/marketplace.selector';

export function loadMarketplaceLocale(marketplaceSelector: MarketplaceStoreSelector): string {
  return marketplaceSelector.marketplace.default_locale?.locale || 'fr-FR';
}
